import React, { PropsWithChildren } from 'react';
import { CardTitle, Col, Row, Spinner } from 'reactstrap';
import { TabPane } from '../../../../../../modules/unsw-tabs';
import PatientInformationSection from '../../../../../../containers/Report/Questionnaire/Sections/Patient';
import EditQuestionnaireResponseButton from '../../../../../../containers/Buttons/EditQuestionnaireResponse';

const Container = ({
  title,
  tabId,
  editable,
  children,
  loading,
}: PropsWithChildren<{
  title: string;
  tabId: string;
  editable?: boolean;
  loading?: boolean;
}>) => {
  return (
    <TabPane tabId={tabId}>
      {loading ? (
        <Spinner />
      ) : (
        <Row>
          <Col sm="12">
            <Row noGutters>
              <Col>
                <CardTitle tag="h2">{title}</CardTitle>
              </Col>
              {editable ? (
                <Col>
                  <EditQuestionnaireResponseButton />
                </Col>
              ) : null}
            </Row>
            <Row className="mb-3">
              <Col xs={12}>
                <PatientInformationSection />
              </Col>
            </Row>
            <Row className="justify-content-between ">{children}</Row>
          </Col>
        </Row>
      )}
    </TabPane>
  );
};

export default Container;
